<template>
    <div class="content">
        <div class="about-exam">
            <div class="title">了解IFM考试</div>
            <div class="info">国际财务管理师（简称IFM）是国际财务管理专业领域的一套职业资格证书体系，2004年5月，经中国人力资源和社会保障部（原劳动和社会保障部、人事部）批准，国际财务管理师职业资格证书体系正式进入中国。</div>
            <div class="more" @click="$router.push('/ifmExam')">更多 ></div>
        </div>
        <div v-for="(item, index) in recommendList.slice(0,3)" :key="index" class="card" @click="$router.push(`/detail?id=${item.id}`)">
            <img :src="item.image">
            <div class="title" :title="item.title">{{item.title}}</div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        recommendList:{
            type:Array,
            default: () => [],
        }
    }
}
</script>
<style lang="scss" scoped>
.content{
    width:1120px;
    margin: auto;
    background: #F0F0F0;
    padding: 29px 32px;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 31px;
}
.about-exam{
    width: 320px;
    .title{
        font-size: 22px;
        color: #235483;
        letter-spacing: 0.62px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .info{
        font-size: 14px;
        color: #3B3B3B;
        letter-spacing: 0.4px;
        font-weight: 400;
        margin: 11px 0 13px 0;
    }
    .more{
        font-size: 14px;
        color: #235483;
        letter-spacing: 0.4px;
        font-weight: 500;
        cursor: pointer;
    }
}
.card{
    border-left: 1px solid #E2E2E2;
    width: 220px;
    margin-left: 20px;
    padding-left: 20px;
    cursor: pointer;
    img{
        width: 220px;
        height: 140px;
    }
    div{
        font-size: 16px;
        color: #235483;
        letter-spacing: 0.45px;
        font-weight: 500;
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        margin-top: 10px;
    }
}
</style>
